import React from "react";

const Button = ({
  variant = "primary",
  loadingText = "Processing...",
  isLoading = false,
  onClick,
  type = "submit",
  children,
  size = "sm",
  className = "",
  icon = null,
}) => {
  const buttonText = isLoading ? loadingText : children;

  const buttonClasses =
    variant === "primary"
      ? "bg-primary text-white hover:bg-primaryDark disabled:bg-black duration-400"
      : variant === "secondary"
      ? "bg-gray-200 text-black hover:bg-gray-200 disabled:bg-gray-400"
      : variant === "danger"
      ? "bg-red-500 text-white hover:bg-red-600 disabled:bg-red-400 duration-400"
      : variant === "earning"
      ? "bg-yellow-500 text-black hover:bg-yellow-600 disabled:bg-yellow-400 duration-400"
      : variant === "info"
      ? "bg-blue-500 text-white hover:bg-blue-600 disabled:bg-blue-400 duration-400"
      : variant === "custom"
      ? "disabled:bg-gray-200 duration-400"
      : "bg-gray-200 text-black hover:bg-gray-200 disabled:bg-gray-200 duration-400";

  const sizeClasses =
    size === "sm"
      ? "text-sm py-2 px-4"
      : size === "lg"
      ? "text-lg py-4 px-8"
      : size === "xs"
      ? "text-[12px] py-1 px-4"
      : "text-base py-3 px-6";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isLoading}
      className={`rounded-md ${buttonClasses} ${sizeClasses} flex items-center justify-center  ${className}`}
    >
      {isLoading && (
        <svg
          className="w-5 h-5 mr-3 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          ></circle>
          <path d="M4 12a8 8 0 0 1 8-8v8z" fill="currentColor"></path>
        </svg>
      )}
      {icon && !isLoading && <span className="mr-2">{icon}</span>}
      {buttonText}
    </button>
  );
};

export default Button;
